import React, { useState, useEffect } from "react";
import DeleteModal from "../../components/Modals/DeleteModal";
import "./team.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack, Delete, Visibility, Add } from "@material-ui/icons";
import { getOneTeam } from "../../services/team.services";
import { getTeamPlayers } from "../../services/player.services";
// import { deleteTeam } from "../../services/team.services";
import { getUserSubscriptionDetails } from "../../services/user.services";

import { useSelector, useDispatch } from "react-redux";
import { getTeamDetails, deleteTeam } from "../../redux/actions/teamActions";

export default function Team(props) {
  const history = useHistory();
  const { subscriptionId } = useParams();
  const dispatch = useDispatch();

  const teamData = useSelector((state) => state.team.teamData); // Get teamData from Redux store

  useEffect(() => {
    dispatch(getTeamDetails(subscriptionId)); // Fetch team details when component mounts
  }, [dispatch, subscriptionId]);

  const handleDelete = async () => {
    try {
      await dispatch(deleteTeam(teamData?.teamId._id)); // Delete team based on teamId
      history.goBack(); // Navigate back after deletion
    } catch (error) {
      console.log("Error deleting team:", error);
    }
  };

  if (!teamData) {
    return <div>Loading...</div>; // Handle loading state if teamData is null
  }

  return (
    <div className="user">
      <div className="userHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTitle">Team Details</h1>
        </div>
        <img className="userLogo" src={logoBlue} alt="logo" width="150px" />
      </div>

      <div className="teamDetailsView">
        <div className="teamName">{teamData?.teamName}</div>
        <div className="teamDetailsView">
          <div className="teamDetailsViewR1">
            <div className="teamDetailsClockType">
              <span>Nickname: </span>
              {teamData?.teamNickName}
            </div>
            {/* Add more team details rendering here */}
          </div>
          <div className="teamDetailsViewR4">
            <button className="goBackBtn" onClick={() => history.goBack()}>
              Go Back
            </button>
            <button className="deleteBtn" onClick={handleDelete}>
              Delete Team
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
